import MaterialDrawer from "@mui/material/Drawer";
import classNames from "classnames";
import { FC, ReactNode } from "react";
import styled from "styled-components";

const StyledDrawer = styled.div`
  width: 350px;

  &.Drawer_width_wide {
    width: 450px;
  }
`;

interface Props {
  children?: ReactNode;
  anchor?: "start" | "end";
  width?: "default" | "wide";
  className?: string;
  isOpen: boolean;
  onClose: () => void;
}

const Drawer: FC<Props> = ({
  anchor,
  width,
  isOpen,
  className,
  onClose,
  children,
}) => {
  // default is end
  const materialAnchor = anchor === "start" ? "left" : "right";

  return (
    <MaterialDrawer anchor={materialAnchor} open={isOpen} onClose={onClose}>
      <StyledDrawer
        className={classNames([`Drawer_width_${width}`, className])}
      >
        {children}
      </StyledDrawer>
    </MaterialDrawer>
  );
};

export { Drawer };
